import React from 'react'
import styled, { css } from 'styled-components'

import LiveSelectOption from 'live/components/forms/ui/select-option'

export const RuleEditor = styled.div`
    background-color: ${({ theme }) => theme['gray-lighter'] || '#eee'};
    margin-bottom: 12px;
    border-radius: 0 0 4px 4px;
    box-shadow: inset 0px 2px 2px rgba(54, 65, 89, 0.2);

    ${({ mustSave, inactive }) =>
        mustSave &&
        css`
            border: 1px solid ${'#37a3ef' + (inactive ? '99' : '')};
            border-top: none;
        `}

    input {
        border: 1px solid ${({ theme }) => theme['gray-light'] || '#dddee1'};
        box-shadow: none;
    }

    .Select-control {
        border: 1px solid ${({ theme }) => theme['gray-light'] || '#dddee1'};
    }
`

export const Divider = styled.hr`
    height: 1px;
    background-color: ${({ theme }) => theme['dash-background'] || '#dddee1'};
    margin: 0;
`

export const RuleToggles = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 16px 0 20px 24px;
`

export const ToggleContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 200px;
    padding: 5px;
    font-size: 13px;
    color: ${({ theme }) => theme['text-color'] || '#364159'};
    border: 1px solid #bac0cb;
    border-radius: 3px;
    margin-right: 20px;

    > .far {
        width: 24px;
        text-align: center;
        font-size: 14px;
        margin-right: 8px;
    }

    > span {
        margin-right: auto;
    }

    ${({ active }) =>
        active &&
        css`
            border-color: #c8ccd4;
            background-color: white;
        `}

    .action-toggle {
        user-select: none;

        .left,
        .right,
        ::before {
            z-index: auto;
        }
    }
`

export const RuleOptions = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px 24px;
`

export const RuleOptionTitle = styled.div`
    display: flex;
    align-items: center;
    height: 32px;
    font-family: ${({ theme }) => theme['font-semibold']};
    margin-bottom: 8px;
`

const selectStyles = css`
    font-size: 13px;
    color: ${({ theme }) => theme['auxiliar-typography'] || '#606a80'};

    > .far,
    > .fas {
        margin-right: 2px;
        font-size: 11px;
    }
`

const SelectOptionWithIcon = styled(LiveSelectOption)`
    ${selectStyles}

    ${({ color }) =>
        color &&
        css`
            > .fas {
                color: ${color};
            }
        `}
`

const StyledComparatorOption = styled(LiveSelectOption)`
    color: ${({ theme }) => theme['auxiliar-typography'] || '#606A80'};
`

// these three are classes to avoid an error with this react-select version and
// the optionComponent prop (something w/ function components and refs)

export class SelectOptionWithIconClass extends React.Component {
    render() {
        return <SelectOptionWithIcon {...this.props} />
    }
}

export class SelectOptionWithIconColor extends React.Component {
    render() {
        // eslint-disable-next-line react/prop-types
        return <SelectOptionWithIcon {...this.props} color={this.props.option.color} />
    }
}

export class ComparatorOption extends React.Component {
    render() {
        return <StyledComparatorOption {...this.props} />
    }
}

export const SelectValueWithIcon = styled.div`
    ${selectStyles}
    padding-right: 15px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    > div {
        display: inline-block;
    }

    > .far,
    > .fas {
        margin-right: 4px;
        margin-bottom: 2px;
    }
`

export const ChannelSelectorValue = styled.div`
    color: ${({ theme }) => theme['auxiliar-typography'] || '#606A80'};
    padding-right: 15px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`

export const Comparator = styled.div`
    color: ${({ theme }) => theme['auxiliar-typography'] || '#606A80'};
    padding-right: 15px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    > span {
        font-family: ${({ theme }) => theme['font-semibold']};
        color: ${({ theme }) => theme['text-color'] || '#364159'};
        margin-right: 4px;
    }
`

export const Conditions = styled.div`
    padding: 16px 24px;

    > table {
        margin-bottom: 16px;

        > tbody {
            background-color: transparent;
        }

        td:first-child,
        th:first-child {
            padding-left: 0;
        }

        th {
            height: 36px;
            font-size: 13px;
            padding: 8px 5px;
        }

        td {
            padding: 4px;

            input:not([type='checkbox']):not([type='radio']) {
                height: 32px;
                border: 1px solid ${({ theme }) => theme['gray-light'] || '#dddee1'};
            }

            .Select-input > input {
                border: 0 !important;
                padding: 8px 0 12px !important;
            }
        }

        td:first-child {
            width: 40%;
        }

        td:nth-child(2) {
            width: 30%;
        }

        /* trash icon */
        td:nth-child(4) {
            text-align: center;
        }
    }
`
